import { Action, createReducer, on } from '@ngrx/store';
import * as DeviceBoardusersActions from './device-boardusers.actions';
import { BoardUsersListsRespData } from 'src/app/model/api/data-rest';

export type State = {
	boardUsersListsRespData: BoardUsersListsRespData;
	loading: boolean;
	versionLists: string;
	exporting: boolean;
	exported: boolean;
	updating: boolean;
	updated: boolean;
	importing: boolean;
	imported: boolean;
};

export const initialState: State = {
	boardUsersListsRespData: undefined,
	loading: false,
	versionLists: '',
	exporting: false,
	exported: false,
	updating: false,
	updated: false,
	importing: false,
	imported: false,
};

const deviceBoardusersReducer = createReducer(
	initialState,
	on(DeviceBoardusersActions.getBoardusersLists, (state) => ({ ...state, boardUsersListsRespData: undefined, loading: true, versionLists: '' })),
	on(DeviceBoardusersActions.getBoardusersListsSuccess, (state, payload) => ({
		...state,
		boardUsersListsRespData: payload.boardUsersResp,
		loading: false,
		versionLists: payload.boardUsersResp.Version,
	})),
	on(DeviceBoardusersActions.getBoardusersListsFailed, (state) => ({
		...state,
		loading: false,
	})),
	on(DeviceBoardusersActions.resetBoarduserListDialog, (state) => ({ ...state, updating: false, updated: false, exporting: false, exported: false })),
	on(DeviceBoardusersActions.exportBoarduserList, (state) => ({ ...state, exporting: true, exported: false })),
	on(DeviceBoardusersActions.exportBoarduserListSuccess, (state) => ({ ...state, exporting: false, exported: true,  })),
	on(DeviceBoardusersActions.exportBoarduserListFailed, (state) => ({ ...state, exporting: false, exported: false,  })),
	on(DeviceBoardusersActions.editBoarduserList, (state) => ({ ...state, updating: true, updated: false })),
	on(DeviceBoardusersActions.editBoarduserListSuccess, (state) => ({ ...state, updating: false, updated: true })),
	on(DeviceBoardusersActions.editBoarduserListFailed, (state) => ({ ...state, updating: false, updated: false })),
	on(DeviceBoardusersActions.resetImportBoarduserListDialog, (state) => ({ ...state, importing: false, imported: false })),
	on(DeviceBoardusersActions.importBoarduserList, (state) => ({ ...state, importing: true, imported: false })),
	on(DeviceBoardusersActions.importBoarduserListSuccess, (state) => ({ ...state, importing: false, imported: true })),
	on(DeviceBoardusersActions.importBoarduserListFailed, (state) => ({ ...state, importing: false, imported: false })),
);

export const reducer = (state: State | undefined, action: Action): State => deviceBoardusersReducer(state, action);
